// --- Modules
import Node, { payload } from './Node';

class DHCP extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'DHCP'
    });
  }
};

export default {
  create: (opts) => {
    let item = new DHCP(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
